import { Router } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import { Flex } from '@opendoor/bricks/core';

import WelcomeLeadPage from '../../src/components/WelcomeLeadPage';
import WelcomeRedirectPage from '../../src/components/WelcomeRedirectPage';
import PublicNotificationPreferences from '../components/PublicNotificationPreferences';
import history from '../config/history';
import trackEvent from '../helpers/trackEvent';
import DeveloperDashboard from './DeveloperDashboard';
import ErrorPage from './ErrorPage';
import LwcDashboard from './LwcDashboard';
import LwcBrokerageDashboard from './LwcDashboard/LwcBrokerageDashboard';
import NotFound from './NotFound';
import ParnDashboard from './ParnDashboard';
import PrivateRoute from './PrivateRoute';
import PurchaseAgreementPage from './PurchaseAgreementPage';
import ReferralDashboard from './ReferralDashboard';
import ReportingDashboard from './ReportingDashboard';
import SingleReportPage from './ReportingDashboard/SingleReportPage';
import {
  DEVELOPER_DASHBOARD_ROUTE,
  ERROR_PAGE_ROUTE,
  LIST_WITH_CERTAINTY_BROKERAGE_DASHBOARD_ROUTE,
  LIST_WITH_CERTAINTY_DASHBOARD_ROUTE,
  PARTNER_AGENT_REFERRAL_NETWORK_DASHBOARD_ROUTE,
  PURCHASE_AGREEMENT_PAGE_ROUTE,
  REFERRAL_DASHBOARD_ROUTE,
  REPORTING_DASHBOARD_ROUTE,
  SIGN_UP_ROUTE,
  SINGLE_REPORT_PAGE_ROUTE,
  SUBSCRIPTION_PREFERENCES_ROUTE,
  WELCOME_LEAD_ROUTE,
  WELCOME_REDIRECT_ROUTE,
} from './routes';
import SignUp from './SignUp';

const Routes = () => {
  trackEvent('view', 'page', { path: history.location.pathname });

  history.listen((location, _action) => {
    trackEvent('view', 'page', { path: location.pathname });
  });

  const renderDevDashBoardWithProps = (props: any) => {
    return <DeveloperDashboard {...props} testMode={true} />;
  };

  const renderDevLogo = () => (
    <Flex>
      <img
        src="https://imgdrop.imgix.net/065e19554f80403eaa59d45a859d2df2.png"
        alt="Opendoor"
        height="25"
      />
    </Flex>
  );

  return (
    // @ts-expect-error - Resolved by updating to react-router v6
    <Router history={history}>
      <Switch>
        <Route exact path={ERROR_PAGE_ROUTE} component={ErrorPage} />
        <Route path={SIGN_UP_ROUTE + '/:slug?'} component={SignUp} />
        <Route path={SUBSCRIPTION_PREFERENCES_ROUTE} component={PublicNotificationPreferences} />
        <Route path={WELCOME_LEAD_ROUTE + '/:sellerInputId'} component={WelcomeLeadPage} />
        <Route path={WELCOME_REDIRECT_ROUTE} component={WelcomeRedirectPage} />
        <PrivateRoute
          path={PURCHASE_AGREEMENT_PAGE_ROUTE(':referralUUID')}
          component={PurchaseAgreementPage}
        />
        <PrivateRoute
          exact
          path={DEVELOPER_DASHBOARD_ROUTE + '/test/:tab?'}
          component={renderDevDashBoardWithProps}
          renderLogo={renderDevLogo}
        />
        <PrivateRoute
          path={DEVELOPER_DASHBOARD_ROUTE + '/:tab?'}
          component={DeveloperDashboard}
          renderLogo={renderDevLogo}
        />
        <PrivateRoute exact path={REPORTING_DASHBOARD_ROUTE} component={ReportingDashboard} />
        <PrivateRoute
          exact
          path={REFERRAL_DASHBOARD_ROUTE + '/:tab?'}
          component={ReferralDashboard}
        />
        {/* LWC Dashboard routing we want to have it so that the routes in this section all have access to the lead data we already fetch on page load. This makes it so we can share the data between the summary view and the details pages */}
        {/* <PrivateRoute exact path={LIST_WITH_CERTAINTY_DASHBOARD_ROUTE} component={LwcDashboard} /> */}

        <PrivateRoute exact path={LIST_WITH_CERTAINTY_DASHBOARD_ROUTE} component={LwcDashboard} />
        <PrivateRoute
          exact
          path={LIST_WITH_CERTAINTY_BROKERAGE_DASHBOARD_ROUTE}
          component={LwcBrokerageDashboard}
        />
        <PrivateRoute
          exact
          path={PARTNER_AGENT_REFERRAL_NETWORK_DASHBOARD_ROUTE}
          component={ParnDashboard}
        />
        <PrivateRoute path={SINGLE_REPORT_PAGE_ROUTE} component={SingleReportPage} />
        <PrivateRoute
          exact
          path="/"
          components={[
            { component: ReportingDashboard, path: REPORTING_DASHBOARD_ROUTE },
            { component: ReferralDashboard, path: REFERRAL_DASHBOARD_ROUTE },
            { component: DeveloperDashboard, path: DEVELOPER_DASHBOARD_ROUTE },
          ]}
        />
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
};

export default Routes;
